<template>
  <form ref="pinCodeUpdateForm" @submit.prevent="updatePinCode" class="space-y-6">
    <div>
      <label class="block font-medium text-sm text-gray-500" for="current_password">
        Текущий пароль
      </label>
      <input v-model="data.current_password"
             class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 block mt-1 w-full" type="password"
             id="current_password" name="current_password" required="required" autocomplete="current-password">
    </div>
    <div>
      <label class="block font-medium text-sm text-gray-500" for="pin_code">
        Новый ПИН-код (4 цифры)
      </label>
      <input v-model="data.pin_code"
             class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 block mt-1 w-full" 
             type="text" pattern="[0-9]{4}" maxlength="4" inputmode="numeric"
             id="pin_code" name="pin_code" required="required">
    </div>
    <div>
      <label class="block font-medium text-sm text-gray-500" for="pin_code_confirmation">
        Подтверждение ПИН-кода
      </label>
      <input v-model="data.pin_code_confirmation"
             class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 block mt-1 w-full" 
             type="text" pattern="[0-9]{4}" maxlength="4" inputmode="numeric"
             id="pin_code_confirmation" name="pin_code_confirmation" required="required">
    </div>
    <div v-if="errors" class="text-red-500 py-2 font-semibold">
      <span>{{ errors.message }}</span>
    </div>
    <div v-if="success" class="text-green-500 py-2 font-semibold">
      <span>{{ success }}</span>
    </div>
    <div class="flex items-center justify-end mt-4">
      <button type="submit"
              class="inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring ring-gray-300 disabled:opacity-25 transition ease-in-out duration-150">
        Обновить
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
  data() {
    return {
      errors: null,
      success: null,
      data: {
        current_password: null,
        pin_code: null,
        pin_code_confirmation: null,
      }
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['attempt_user']),
    updatePinCode() {
      // Сначала проверяем совпадение PIN-кодов
      if (this.data.pin_code !== this.data.pin_code_confirmation) {
        this.errors = { message: 'ПИН-код и подтверждение не совпадают' };
        return;
      }
      
      // Проверяем, что PIN состоит из 4 цифр
      if (!/^\d{4}$/.test(this.data.pin_code)) {
        this.errors = { message: 'ПИН-код должен состоять из 4 цифр' };
        return;
      }
      
      this.errors = null;
      this.success = null;
      
      axios.post('/api/user/updatePinCode', this.data)
        .then((response) => {
          this.success = response.data.message || 'ПИН-код успешно обновлен';
          this.$refs.pinCodeUpdateForm.reset();
          this.data = {
            current_password: null,
            pin_code: null,
            pin_code_confirmation: null,
          };
        })
        .catch((error) => {
          this.errors = error.response.data;
        });
    },
  }
}
</script> 